import api from '@/lib/axios';

export type FeatureSource = 'manual' | 'addon' | null;

export interface FeatureFlag {
  featureKey: string;
  label: string;
  isEnabled: boolean;
  /** Origem da ativação: 'manual' = override pelo admin, 'addon' = add-on contratado, null = desabilitado */
  source: FeatureSource;
  config: Record<string, any> | null;
}

export interface UpsertFeatureFlagDto {
  featureKey: string;
  isEnabled: boolean;
  config?: Record<string, any>;
}

class FeatureFlagsService {
  async listMy(): Promise<FeatureFlag[]> {
    const response = await api.get<FeatureFlag[]>('/features/my');
    return response.data;
  }

  /** Somente leitura - ativação de módulos é exclusiva da plataforma (System Admin) */
  async list(): Promise<FeatureFlag[]> {
    const response = await api.get<FeatureFlag[]>('/features');
    return response.data;
  }

  async listForTenant(tenantId: string): Promise<FeatureFlag[]> {
    const response = await api.get<FeatureFlag[]>(`/features/admin/${tenantId}`);
    return response.data;
  }

  async upsertForTenant(
    tenantId: string,
    dto: UpsertFeatureFlagDto,
  ): Promise<FeatureFlag> {
    const response = await api.put<FeatureFlag>(`/features/admin/${tenantId}`, dto);
    return response.data;
  }

  /** Remove o override manual; a feature passa a depender do add-on contratado */
  async removeOverrideForTenant(
    tenantId: string,
    featureKey: string,
  ): Promise<void> {
    await api.delete(`/features/admin/${tenantId}/${featureKey}`);
  }
}

export const featureFlagsService = new FeatureFlagsService();
